// import companyName from '../store/mobxStore/companyName';
// const COMPANY_NAME =companyName.companyName??'Company Name';
// const BASE_URL = "http://192.168.9.8:5023/api/web/";
// const IMG_URL = "http://192.168.9.8:5023/uploads/images/";
// const LEAD_URL = "http://192.168.9.8:5023/api/web/";
// const API_KEY =localStorage.getItem('apiKey'); //binaryaddon;
// // const DEFAULT_KEY ='903's
// const DEFAULT_KEY='387245a5a919ea2071cc406b10b89d4685e5cc8e'
// const BASE = "http://192.168.9.8:5023/";

//LOCAL - Akhila
// import companyName from "../store/mobxStore/companyName";
// const COMPANY_NAME = companyName.companyName ?? "Company Name";
// const BASE_URL = "http://192.168.10.47:5000/api/web/";
// const IMG_URL = "http://192.168.10.47:5000/uploads/images/";
// const LEAD_URL = "http://192.168.10.47:5000/api/web/";
// const API_KEY = localStorage.getItem("apiKey"); //binaryaddon;
// // const DEFAULT_KEY ='903's
// const DEFAULT_KEY = "387245a5a919ea2071cc406b10b89d4685e5cc8e";
// const BASE = "http://192.168.10.47:5000/";

// LOCAL - Dheeraj
// import companyName from "../store/mobxStore/companyName";
// const COMPANY_NAME = companyName.companyName ?? "Company Name";
// const BASE_URL = "http://localhost:5000/api/web/";
// const IMG_URL = "http://localhost:5000/uploads/images/";
// const LEAD_URL = "http://localhost:5000/api/web/";
// const API_KEY = localStorage.getItem("apiKey"); //binaryaddon;
// // const DEFAULT_KEY ='903's
// const DEFAULT_KEY = "387245a5a919ea2071cc406b10b89d4685e5cc8e";
// const BASE = "http://localhost:5000/";
// const WEB_SITE_URL = "http://localhost/";

// DEMO
// import companyName from "../store/mobxStore/companyName";
// const COMPANY_NAME = companyName.companyName ?? "Company Name";
// const BASE_URL = "http://162.19.146.135:1178/api/web/";
// const IMG_URL = "http://162.19.146.135:1178/uploads/images/";
// const LEAD_URL = "http://162.19.146.135:1178/api/web/";
// const API_KEY = localStorage.getItem("apiKey"); //binaryaddon;
// // const DEFAULT_KEY ='903's
// const DEFAULT_KEY = "387245a5a919ea2071cc406b10b89d4685e5cc8e";
// const BASE = "http://162.19.146.135:1178/";

// //LIVE
// import companyName from "../store/mobxStore/companyName";
// const COMPANY_NAME = companyName.companyName ?? "Company Name";
// const BASE_URL = "http://20.205.159.50:5000/api/web/";
// const IMG_URL = "http://20.205.159.50:5000/uploads/images/";
// const LEAD_URL = "http://20.205.159.50:5000/api/web/";
// const API_KEY = localStorage.getItem("apiKey");
// const DEFAULT_KEY = "387245a5a919ea2071cc406b10b89d4685e5cc8e";
// const BASE = "http://20.205.159.50:5000/";
// const WEB_SITE_URL = "http://20.205.159.50/"
// const WORDPRESS_URL = "http://20.205.159.50:8081/"

// DEMO - LIVE
// import companyName from "../store/mobxStore/companyName";
// const COMPANY_NAME = companyName.companyName ?? "Company Name";
// const BASE_URL = "http://4.194.16.59:5000/api/web/";
// const IMG_URL = "http://4.194.16.59:5000/uploads/images/";
// const LEAD_URL = "http://4.194.16.59:5000/api/web/";
// const API_KEY = localStorage.getItem("apiKey"); //binaryaddon;
// // const DEFAULT_KEY ='903's
// const DEFAULT_KEY = "387245a5a919ea2071cc406b10b89d4685e5cc8e";
// const BASE = "http://4.194.16.59:5000/";
// const WEB_SITE_URL = "http://4.194.16.59/";
// const WORDPRESS_URL = "http://4.194.16.59:8081/";


// ORIGINAL LIVE 
// import companyName from "../store/mobxStore/companyName";
// const COMPANY_NAME = companyName.companyName ?? "Company Name";
// const BASE_URL = "http://52.163.57.156:5000/api/web/";
// const IMG_URL = "http://52.163.57.156:5000/uploads/images/";
// const LEAD_URL = "http://52.163.57.156:5000/api/web/";
// const API_KEY = localStorage.getItem("apiKey"); //binaryaddon;
// // const DEFAULT_KEY ='903's
// const DEFAULT_KEY = "387245a5a919ea2071cc406b10b89d4685e5cc8e";
// const BASE = "http://52.163.57.156:5000/";
// const WEB_SITE_URL = "http://52.163.57.156/";
// const WORDPRESS_URL = "http://52.163.57.156:8081/";


import companyName from "../store/mobxStore/companyName";
const COMPANY_NAME = companyName.companyName ?? "Company Name";
const BASE_URL = "https://adminportal.ifernglobal.com.ph/node_api/web/";
const IMG_URL = "https://adminportal.ifernglobal.com.ph/node_api/uploads/images/";
const LEAD_URL = "https://adminportal.ifernglobal.com.ph/node_api/web/";
const API_KEY = localStorage.getItem("apiKey"); //binaryaddon;
// const DEFAULT_KEY ='903's
const DEFAULT_KEY = "387245a5a919ea2071cc406b10b89d4685e5cc8e";
const BASE = "https://adminportal.ifernglobal.com.ph/node_api/";
const WEB_SITE_URL = "https://membersportal.ifernglobal.com.ph/";
const WORDPRESS_URL = "http://register.ifernglobal.com.ph/";

//REPLICA Server


// import companyName from "../store/mobxStore/companyName";
// const COMPANY_NAME = companyName.companyName ?? "Company Name";
// const BASE_URL = "http://20.191.157.40:5000/api/web/";
// const IMG_URL = "http://20.191.157.40:5000/api/uploads/images/";
// const LEAD_URL = "http://20.191.157.40:5000/api/web/";
// const API_KEY = localStorage.getItem("apiKey"); //binaryaddon;
// // const DEFAULT_KEY ='903's
// const DEFAULT_KEY = "387245a5a919ea2071cc406b10b89d4685e5cc8e";
// const BASE = "http://20.191.157.40:5000/api/";
// const WEB_SITE_URL = "https://http://20.191.157.40:8060/";
// const WORDPRESS_URL = "https://http://20.191.157.40:8081/";

export {
  COMPANY_NAME,
  BASE_URL,
  IMG_URL,
  API_KEY,
  BASE,
  DEFAULT_KEY,
  LEAD_URL,
  WEB_SITE_URL,
  WORDPRESS_URL,
};
